import { render, staticRenderFns } from "./AnnualizationYear.vue?vue&type=template&id=0b644e3e&scoped=true"
import script from "./AnnualizationYear.vue?vue&type=script&lang=js"
export * from "./AnnualizationYear.vue?vue&type=script&lang=js"
import style0 from "./AnnualizationYear.vue?vue&type=style&index=0&id=0b644e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b644e3e",
  null
  
)

export default component.exports